export default __webpack_public_path__ + "static/media/3.40fc8e52.jpg";